import angular from "angular";
import csmCommonWeb from "csm-common-web";
/** BooksData */
import { RunDGJournalItem } from "./BooksData/DGJournalItem";
import { RunItemSalesAcct } from "./BooksData/ItemSalesAcct";
import { RunTag } from "./BooksData/Tag";
/** DB */
import { RunStoreItem } from "./db/StoreItem";
/** rws */
import { RunOption } from "./rws/Option";
import { RunOptionValue } from "./rws/OptionValue";
import { RunProduct } from "./rws/Product";


/*******************************************************************************
 * @ngdoc    service
 * @name     csm.books.data.service:BooksData
 * @description
 * CSM Books "BooksData" service initializer. Holds CSM books data model classes.
 * Classes in the 'data' folder are added to this service with run blocks. Each
 * class is in its own file.
 *******************************************************************************/
export default angular
  .module('csm.books.data', [csmCommonWeb, 'csm.util.tools'])
  .factory('BooksData', booksDataFactory)
  .run(RunDGJournalItem)
  .run(RunItemSalesAcct)
  .run(RunTag)
  .run(RunStoreItem)
  .run(RunOption)
  .run(RunOptionValue)
  .run(RunProduct)
  .name;


booksDataFactory.$inject = [];

/* @ngInject */  function booksDataFactory() {
  return {
    /**
     * @ngdoc      property
     * @name       csm.books.data.service:BooksData#db
     * @propertyOf csm.books.data.service:BooksData
     * @description
     * Books DB row classes corresponding to the C# classes in 'csm.booksdb.data'.
     */
    db: {},
  
    /**
     * @ngdoc      property
     * @name       csm.books.data.service:BooksData#rws
     * @propertyOf csm.books.data.service:BooksData
     * @description
     * Data classes corresponding to the C# classes from 'rws.data, CSMBooksRWS'.
     */
    rws: {}
  }
}